<template>
  <div class="container">
    <div class="page-title">
      <div class="title">我要下载</div>
      <div class="marquee">
          <div class="text">
            <p>温馨提示：1. 勿将图库内模板上传至第三方素材网站用于无偿或有偿分享、售卖，如有违反，我们保留向您追偿的权利，谢谢合作；
2. 自下载之日起算7天内再次下载，不重复减扣下载次数。
            </p>
          </div>
      </div>
    </div>
    <div class="content">
      <div class="date-box" style="padding-left: 8px;display: flex;justify-content: center;margin: 20px 0;">
        <el-input
          style="width: 500px;margin-right: 20px;"
          placeholder="直接输入作品编号即可"
          v-model="name"
          clearable>
        </el-input>
        <el-button type="primary" size="middle" icon="el-icon-search" @click="search">查询</el-button>
      </div>
      <div class="image-box">
        <div v-for="(item,index) in bigTypes" :key="index" class="image-item" @click="query(item.id)">
          <div class="image-src">{{item.name}}</div>
          <div class="image-notice" @click="query(item.id)">点击查看</div>
        </div>
      </div>
    </div>
    <el-dialog
      title="公告"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <div style="height: 450px;overflow: auto;" v-html="content"></div>
      <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关 闭</el-button>
          </span>
    </el-dialog>
<!--    <el-pagination-->
<!--      @size-change="handleSizeChange"-->
<!--      @current-change="handleCurrentChange"-->
<!--      :current-page="currentPage"-->
<!--      :page-size="pageSize"-->
<!--      :page-sizes="[5, 10, 20, 40]"-->
<!--      layout="total, sizes, prev, pager, next, jumper"-->
<!--      background-->
<!--      :total="total"-->
<!--    ></el-pagination>-->
  </div>
</template>
<script>
  export default {
    data() {
      return {
        textarea: '',
        orderInfo: '',
        total: 0,
        pageSize: 10,
        currentPage:1,
        listLoading: false,
        bigTypes:[],
        name: '',
        total: 0,
        pageSize: 20,
        currentPage:1,
        dialogVisible: false,
        content: ''
      };
    },
    activated () {
      this.name = '';
      this.queryBigTypes(this.currentPage,this.pageSize); //查询大类
      // this.queryNotice();
    },
    methods: {
      queryNotice(){
        this.$http.post(`/plan/queryNotice`, {}, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====queryOptions',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              if(res.data.data && res.data.data.content){
                this.content = res.data.data && res.data.data.content;
                this.dialogVisible = true;
              }
            } else {

            }
          });
      },
      queryBigTypes(currentPage,pageSize){
        const data = {};
        if(this.name){
          data.name = this.name;
          data.parentId = null;
        }else{
          data.name = '';
          data.parentId = 0;
        }
        this.$http.post(`/user/getFileListByPath/${currentPage}/${pageSize}`, data, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            console.log('res====queryOptions',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              if(this.name){
                if(res.data.data.list.length > 0){
                  const id = res.data.data.list[0].parentId
                  this.$router.push({ name: "LoadList",query:{listData: res.data.data,id} });
                  // this.query(id);
                }else{
                  this.$message.error('未查询到数据')
                }
              }else{
                this.bigTypes = res.data.data.list;
              }
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      query(id){
        // this.$router.push({ name: "specificList",query:{firstId} });
        this.$router.push({ name: "LoadList",query:{id} });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      search(){
        this.currentPage = 1;
        this.queryBigTypes(this.currentPage,this.pageSize);
      },
    },
  };
</script>
<style lang="less" scoped>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    /*width: 90%;*/
    overflow: auto;
    .title {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      margin-bottom: 30px;
      /*color: red;*/
      font-size: 26px;
    }
    .image-box {
      display: flex;
      flex-wrap: wrap;
      margin: 0 50px;
      .image-item {
        display: flex;
        flex-direction: column;
        margin: 0 40px 20px 0;
        cursor:pointer;
        .image-src {
          width: 300px;
          height: 150px;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 40px;
          border: 1px solid #333;
        }
        .image-notice {
          color: red;
        }
      }
    }
    .menu {
      margin: 0 auto;
      width: 90%;
      display: flex;
      flex-direction: column;
      .menu-title {
        font-size: 16px;
        text-align: left;
        margin-bottom: 10px;
      }
    }
  }
  .title {
    margin-right: 20px;
    width: 80px;
  }
  .marquee {
    overflow: hidden;
    white-space: nowrap;
    .text {
      display: inline-block;
      animation-name: marquee;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-play-state: running;
      animation-duration: 35s;
    }
  }
  @keyframes marquee {
    from { transform: translateX(100%);}
    to { transform: translateX(-100%);}
  }
</style>
